import { BrowserRouter as AppRouter, Route } from "react-router-dom"
import { Routes } from "react-router"
import { ROUTES } from "./routes"
import React from "react"
import PrivateRoute from "./PrivateRoute"
import NotFound from "../components/NotFound"
import { DEFAULT_ROUTE } from "../constants"
import { lang } from "../constants/languages"

const Router = () => {
  return (
    <AppRouter basename={process.env.REACT_APP_BASENAME}>
      <Routes>
        {ROUTES.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<PrivateRoute {...route}>{route.element}</PrivateRoute>}
            />
          )
        })}
        <Route
          path="*"
          element={
            <NotFound
              title={lang.not_found.router.title}
              description={lang.not_found.router.desc}
              buttonText={lang.not_found.router.button}
              buttonLink={DEFAULT_ROUTE}
              imageWidth={350}
              titleSize={36}
              descriptionSize={20}
            />
          }
        />
      </Routes>
    </AppRouter>
  )
}

export default Router
